<template>
  <VDialog :value="value" :fullscreen="isFullscreen" :max-width="maxWidth">
    <VSheet
      class="position-relative d-flex flex-column"
      :height="isFullscreen ? '100vh' : null"
    >
      <div class="d-flex">
        <div class="spacer d-flex justify-start">
          <slot name="prepend"></slot>
        </div>
        <div class="flex-grow-1 d-flex align-center justify-center">
          <span
            v-if="title"
            class="text-uppercase l-spacing-half font-size-s font-weight-bold l-height-25"
            >{{ title }}</span
          >
        </div>
        <div class="spacer d-flex justify-end">
          <slot name="header-append-icons">
            <VBtn variant="text" icon="custom:close" @click="$emit('close')" />
          </slot>
        </div>
      </div>
      <!-- auto, not scroll: a permanent track showed even in dialogs whose
           content fits, like the short outcome messages. -->
      <div
        class="flex-grow-1 pt-2 w-100 overflow-y-auto overflow-x-hidden px-3"
      >
        <slot />
      </div>
    </VSheet>
  </VDialog>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)

export default {
  emits: ['close'],
  components: { SvgWrapper },
  props: {
    value: Boolean,
    title: String,
    // Content-heavy dialogs (nav, filters, address and payment forms) want the
    // mobile takeover. Short outcome messages do not, so they can opt out.
    disableMobileFullscreen: Boolean,
    // Without a cap the sheet stretches to the overlay's full width, which is
    // far too wide for a couple of lines of copy.
    maxWidth: [String, Number]
  },
  computed: {
    isFullscreen() {
      return this.$vuetify.display.mdAndDown && !this.disableMobileFullscreen
    }
  }
}
</script>

<style scoped>
.spacer {
  flex: 1;
}
</style>
